<h1 mat-dialog-title class="text-center font-weight-bold mb-3">{{element.title}}</h1>

<mat-dialog-content>
	<h3>
		{{element.message}}
	</h3>
</mat-dialog-content>
<mat-dialog-actions class="justify-content-center row mb-2">
	<button mat-raised-button color="primary" class=" mr-2 mb-2"  (click)="onConfirmClick()" tabindex="-1">{{element.buttonText?.ok}}</button>
	<button mat-raised-button  class="mb-2"  mat-dialog-close tabindex="-1">{{element.buttonText?.cancel}}</button>
</mat-dialog-actions>


